import {TokenService} from "../../services/token.service";

// @ts-nocheck
export default {
    data() {
        return {
            user: TokenService.getUserObj()
        }
    }
}